// extracted by mini-css-extract-plugin
module.exports = {"root":"FeaturedFilterList_root__gMry8","icons":"FeaturedFilterList_icons__tWJMW"};